export const CONTAINER_WIDTH_ON_SCROLL = 100;

export const SHRINK_SCROLL_THRESHOLD_PX = 2;
export const EXPAND_SCROLL_THRESHOLD_PX = 2;

export const MIN_OVERFLOW_AFTER_SHRINK_PX = 8;

export const SHRINK_ANIMATION_MAX_ROWS = 25;

export const TABLE_HEADER_ELEMENT_HEIGHT = "64px";

export const CLASS_TABLE_CONTEXT_MENU_BUTTON = "table-context-menu-button";
export const TABLE_FIRST_COLUMN_WIDTH = ["229px", "229px", "250px", "425px"];
export const TABLE_CELL_MIN_WIDTH = ["unset", "unset", "80px", "120px"];
